export const getTargetLanguage = (state) => {
    return state && state.language && state.language.targetLanguage
}

export const getPendingTranslations = (state) => {
    return state.language.pendingTranslations
}

export const getLanguageMap = (state) => {
    return state && state.language && state.language.languageMap
}
